import { render, staticRenderFns } from "./EknoStatReportTemplateEditor.vue?vue&type=template&id=5b8f9995&scoped=true"
import script from "./EknoStatReportTemplateEditor.vue?vue&type=script&lang=js"
export * from "./EknoStatReportTemplateEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8f9995",
  null
  
)

export default component.exports